export default   [
    'rgba(54, 162, 235, 1)',
    'rgba(255, 99, 132, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
    "rgba(129, 199, 132, 1)",
    "rgba(111, 172, 202, 1)",
    "rgb(191, 64, 64, 1)",
    "rgb(142, 140, 110, 1)",
    "rgba(0, 81, 107, 1)",
    "rgba(255, 179, 255)",
  ];